import { IdtComponentCmsDefinition, CmsComponentGroups } from 'shared/idt-components/idt-components-cms.model';
import { IdtComponentRole } from 'shared/models/idt-components/idt-component-role.models';
import { IdtComponentDefinition } from 'shared/models/idt-components/idt-component.models';

import { SliceStylesDefaultValues } from 'extensions/core/slice-base/models/slice-base.settings.model';
import { initialSliceSlotState } from 'extensions/core/slice-base/models/slice-slot.settings.model';

import { SliceFlexSettings } from './slice-flex-settings.model';


export const SLICE_FLEX_DEFAULT_CUSTOM_CURSOR_SIZE = '64px';

export const SliceFlexDefinition: IdtComponentDefinition = {
  id: 'slice-flex',
  role: IdtComponentRole.Slice,
  numSlots: 1,
  defaultSlot: 1
};

export const SliceFlexCmsDefinition: IdtComponentCmsDefinition = {
  name: 'Sección',
  group: CmsComponentGroups.Basic,
  availablePlatforms: ['web', 'apps'],
  initialSettings: (): SliceFlexSettings => {
    return {
      general: {
        alignContent: 'stretch',
        alignItems: 'flex-start',
        closeSection: false,
        closeSectionType: 'icon',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        gap: '0px',
        justifyContent: 'center',
        keepCloseSection: false,
        numSlots: 1
      },
      slots: [
        { ...initialSliceSlotState }
      ],
      styles: SliceStylesDefaultValues
    };
  }
};
